// extracted by mini-css-extract-plugin
export default {"SignInPanel":"Styles_SignInPanel__Hn-T-","MessageBox":"Styles_MessageBox__PDr+5","SubmitButton":"Styles_SubmitButton__YUeOp"};